module.exports = __webpack_public_path__ + "media/images/vp/icon.statistics.white-d0ce52843cbaa3241e6ab5dd98d572b8.svg";